import Hero from '../components/Hero';
import CategoryGrid from '../components/CategoryGrid';
import ProductShowcase from '../components/ProductShowcase';
import Features from '../components/Features';
import Stories from '../components/Stories';

export default function Home() {
  return (
    <div data-testid="page-home">
      <Hero />
      <CategoryGrid />
      <ProductShowcase />
      <Features />
      {/* StatsAndTestimonials disembunyikan sementara (permintaan user) — komponen tetap ada di ../components/StatsAndTestimonials */}
      <Stories />
    </div>
  );
}
